<script lang="ts">
  import { link, location } from 'svelte-spa-router';
</script>

<div class="not-found">
  <div class="not-found-content">
    <h1>{__STRINGS__.errors.notFoundCode}</h1>
    <h2>{__STRINGS__.errors.notFoundHeading}</h2>
    <p>{__STRINGS__.errors.notFoundMessage.replace('{path}', $location)}</p>
    <div class="actions">
      <a href="/" use:link class="home-link">{__STRINGS__.errors.goToHome}</a>
      <a href="/search" use:link class="search-link">{__STRINGS__.errors.search}</a>
    </div>
  </div>
</div>

<style>
  .not-found {
    min-height: 60vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    text-align: center;
  }

  .not-found-content {
    max-width: 500px;
  }

  h1 {
    margin: 0;
    font-size: 6rem;
    font-weight: 700;
    color: var(--color-primary, #e94560);
    line-height: 1;
  }

  h2 {
    margin: 0.5rem 0 1rem;
    font-size: 1.5rem;
    color: var(--color-heading, #1a1a2e);
  }

  p {
    margin: 0 0 1.5rem;
    color: var(--color-text-muted, #666);
  }

  .actions {
    display: flex;
    gap: 1rem;
    justify-content: center;
  }

  .home-link {
    padding: 0.75rem 1.5rem;
    background: var(--color-primary, #e94560);
    color: white;
    border-radius: 6px;
    text-decoration: none;
    transition: background 0.15s;
  }

  .home-link:hover {
    background: var(--color-primary-dark, #c73e54);
  }

  .search-link {
    padding: 0.75rem 1.5rem;
    border: 1px solid var(--color-border, #e0e0e0);
    border-radius: 6px;
    color: var(--color-text, #333);
    text-decoration: none;
    transition: background 0.15s;
  }

  .search-link:hover {
    background: var(--color-surface, #f9f9f9);
  }
</style>
